import { render, staticRenderFns } from "./Create-Claim.vue?vue&type=template&id=72d5d683&scoped=true"
import script from "./Create-Claim.vue?vue&type=script&lang=js"
export * from "./Create-Claim.vue?vue&type=script&lang=js"
import style0 from "./Create-Claim.vue?vue&type=style&index=0&id=72d5d683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5d683",
  null
  
)

export default component.exports